import * as React from "react";
import { forwardRef, memo } from "react";
const SvgExpandUpDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "icon/expand-up-down" }, /* @__PURE__ */ React.createElement("path", { id: "ic", d: "M10.6206 5.27499L6.99982 1.65417L3.37899 5.27499L4.20395 6.09994L6.99982 3.30409L9.79568 6.09994L10.6206 5.27499ZM3.37891 8.72506L6.9997 12.3459L10.6205 8.72506L9.79556 7.90011L6.9997 10.696L4.20386 7.90011L3.37891 8.72506Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgExpandUpDown);
const Memo = memo(ForwardRef);
export default Memo;
